export default __webpack_public_path__ + "static/media/ic_giga_family_tray@3x.7b58895d.png";